export default __webpack_public_path__ + "static/media/logo.436e4a87.svg";